import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eee60cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Avg: ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "show", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "hide", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Direction: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "horizontal" }, "horizontal", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "vertical" }, "vertical", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Responsive = _resolveComponent("Responsive")!

  return (_openBlock(), _createBlock(_component_Responsive, { class: "w-full" }, {
    main: _withCtx(({ width }) => [
      _createVNode(_component_Chart, {
        size: { width, height: 420 },
        data: _ctx.data,
        margin: _ctx.margin,
        direction: _ctx.direction,
        axis: _ctx.axis
      }, {
        layers: _withCtx(() => [
          _createVNode(_component_Grid, { strokeDasharray: "2,2" }),
          _createVNode(_component_Bar, {
            dataKeys: ['name', 'pl'],
            barStyle: { fill: '#99d98c' },
            maxWidth: 50
          }),
          _createVNode(_component_Bar, {
            dataKeys: ['name', 'avg'],
            barStyle: { fill: '#52b69a' },
            maxWidth: 50
          }),
          (_ctx.marker)
            ? (_openBlock(), _createBlock(_component_Marker, {
                key: 0,
                value: 1000,
                label: "Avg.",
                color: "#e76f51",
                strokeWidth: "2",
                strokeDasharray: "6 6"
              }))
            : _createCommentVNode("", true)
        ]),
        widgets: _withCtx(() => [
          _createVNode(_component_Tooltip, {
            borderColor: "#99d98c",
            config: {
              pl: { color: '#99d98c' },
              avg: { color: '#52b69a' },
              inc: { hide: true }
            }
          }),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _withDirectives(_createElementVNode("select", {
              class: "mr-4",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.marker) = $event))
            }, _hoisted_5, 512), [
              [_vModelSelect, _ctx.marker]
            ]),
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.direction) = $event))
            }, _hoisted_9, 512), [
              [_vModelSelect, _ctx.direction]
            ])
          ])
        ]),
        _: 2
      }, 1032, ["size", "data", "margin", "direction", "axis"])
    ]),
    _: 1
  }))
}